var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "virtual-tree" },
    [
      _c("vxe-list", {
        ref: "virtualTree",
        staticClass: "my-tree",
        attrs: { maxHeight: "240", loading: _vm.loading, data: _vm.list },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var items = ref.items
              return _vm._l(items, function(item) {
                return _c(
                  "div",
                  {
                    key: item[_vm.props.id],
                    staticClass: "my-tree-item",
                    class: [
                      "level-" + item._LEVEL,
                      {
                        "has-child": item._HAS_CHILDREN,
                        "is-expand": item._EXPAND,
                        active:
                          "" + _vm.activeValue === "" + item[_vm.props.id],
                        "single-item": !_vm.multiple
                      }
                    ],
                    style: {
                      paddingLeft: item._LEVEL * +_vm.indentValue + "px"
                    }
                  },
                  [
                    _c("i", {
                      staticClass:
                        "tree-icon vxe-icon-caret-right el-icon-caret-right",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleTreeNode(item)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.multiple
                      ? _c("el-checkbox", {
                          staticClass: "my-tree-checkbox",
                          attrs: {
                            disabled:
                              _vm.disabled || item.readonly || item.disabled
                          },
                          on: {
                            change: function($event) {
                              return _vm.checkboxChange($event, item)
                            }
                          },
                          model: {
                            value: item.checked,
                            callback: function($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    +_vm.textSize > 0 && item._TEXT.length > +_vm.textSize
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(item._TEXT))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "tree-label",
                                class: [
                                  { "tree-label__delete": item["_DELETE"] },
                                  { "tree-label__disable": item["disabled"] }
                                ],
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.labelClick(item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item._TEXT.substring(0, +_vm.textSize - 1)
                                  ) + "..."
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "tree-label",
                            class: [
                              { "tree-label__delete": item["_DELETE"] },
                              { "tree-label__disable": item["disabled"] }
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.labelClick(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item._TEXT))]
                        )
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e1ccaf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1ccaf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/virtualTree/src/virtualTree.vue
// module id = null
// module chunks = 